/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as yup from "yup";

export const tagSchema = yup.object().shape({
  name: yup.string().required(),
  value: yup.string().required(),
});
